module.exports = __webpack_public_path__ + "img/logolaa.7f6d0d23.png";